import { isDefined } from "../../helpers";
import { getMenuOptions } from "../../data/menu";
export default function (store, { id, type, source }) {
    if (!isDefined(type))
        return;
    let { menu } = store.getState();
    if (menu === true) {
        menu = getMenuOptions;
    }
    if (!menu)
        return;
    let options = menu({
        store,
        type,
        id,
        source,
    });
    if (!options || (Array.isArray(options) && !options.length))
        return;
    if (options == true) {
        options = getMenuOptions({
            store,
            type,
            id,
            source,
        });
    }
    store.setState({
        menuState: {
            id,
            type,
            source,
            options: options,
        },
    });
}
//# sourceMappingURL=open.js.map